<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <!-- <b-form-radio-group
      v-model="search.payment"
      :options="options.payment"
      @change="changePayment"
    ></b-form-radio-group> -->

    <div class="operate">
      <b-form-group class="mb-2" label-cols="auto" label-cols-lg="auto" label="顯示方式">
        <b-form-radio-group
          class="d-flex align-items-center h-100"
          v-model="search.type"
          :options="options.type"
          @change="changeType"
        ></b-form-radio-group>
      </b-form-group>

      <div class="d-flex align-items-center justify-content-between mb-2">
        <b-form-group class="mb-0" label-cols="auto" label-cols-lg="auto" label="繳款日期">
          <div class="d-flex">
            <date-picker
              class="mr-2"
              v-model="search.pay_date_S"
              :position="'left'"
              placeholder="開始"
            ></date-picker>

            <date-picker
              class="mr-2"
              v-model="search.pay_date_E"
              :position="'left'"
              placeholder="結束"
            ></date-picker>
          </div>
        </b-form-group>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-4">
        <b-form-group class="mb-0" label-cols="auto" label-cols-lg="auto" label="異動日期">
          <div class="d-flex">
            <date-picker
              class="mr-2"
              v-model="search.updated_date_S"
              :position="'left'"
              placeholder="開始"
            ></date-picker>

            <date-picker
              class="mr-2"
              v-model="search.updated_date_E"
              :position="'left'"
              placeholder="結束"
            ></date-picker>

            <b-button variant="primary" @click="searchBillReport()">查詢</b-button>
          </div>
        </b-form-group>

        <div class="badge">
          <span>
            總計：
            <span v-if="data.total > 0" class="link" @click="detailedReport({}, 'all_total_sum')">{{ data.total }}</span>
            <span v-else>{{ data.total }}</span>
          </span>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      v-on:result="getBillReport"
    >
      <template #cell(payment_at)="row">
        {{ convertRocDate(row.item.payment_at, false) }}
      </template>

      <template #cell(total_account)="row">
        <span v-if="row.item.total_account" class="link" @click="detailedReport(row.item, 'account')">{{ row.item.total_account }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_0)="row">
        <span v-if="row.item.total_0" class="link" @click="detailedReport(row.item, 0)">{{ row.item.total_0 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_1)="row">
        <span v-if="row.item.total_1" class="link" @click="detailedReport(row.item, 1)">{{ row.item.total_1 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_2)="row">
        <span v-if="row.item.total_2" class="link" @click="detailedReport(row.item, 2)">{{ row.item.total_2 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_3)="row">
        <span v-if="row.item.total_3" class="link" @click="detailedReport(row.item, 3)">{{ row.item.total_3 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_4)="row">
        <span v-if="row.item.total_4" class="link" @click="detailedReport(row.item, 4)">{{ row.item.total_4 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_5)="row">
        <span v-if="row.item.total_5" class="link" @click="detailedReport(row.item, 5)">{{ row.item.total_5 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_6)="row">
        <span v-if="row.item.total_6" class="link" @click="detailedReport(row.item, 6)">{{ row.item.total_6 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_7)="row">
        <span v-if="row.item.total_7" class="link" @click="detailedReport(row.item, 7)">{{ row.item.total_7 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_8)="row">
        <span v-if="row.item.total_8" class="link" @click="detailedReport(row.item, 8)">{{ row.item.total_8 }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_9)="row">
        <span v-if="row.item.total_9" class="link" @click="detailedReport(row.item, 9)">{{ row.item.total_9 }}</span>

        <span v-else>-</span>
      </template>

      <!-- <template #cell(total_10)="row">
        <span v-if="row.item.total_10" class="link" @click="detailedReport(row.item, 10)">{{ row.item.total_10 }}</span>

        <span v-else>-</span>
      </template> -->

      <template #cell(total_Y)="row">
        <span v-if="row.item.total_Y" class="link" @click="detailedReport(row.item, 'Y')">{{ row.item.total_Y }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_F)="row">
        <span v-if="row.item.total_F" class="link" @click="detailedReport(row.item, 'F')">{{ row.item.total_F }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_S)="row">
        <span v-if="row.item.total_S" class="link" @click="detailedReport(row.item, 'S')">{{ row.item.total_S }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_B)="row">
        <span v-if="row.item.total_B" class="link" @click="detailedReport(row.item, 'B')">{{ row.item.total_B }}</span>

        <span v-else>-</span>
      </template>

      <template #cell(total_sum)="row">
        <span v-if="row.item.total_sum" class="link" @click="detailedReport(row.item, 'sum')">{{ row.item.total_sum }}</span>

        <span v-else>-</span>
      </template>

      <template #custom-foot>
        <tr>
          <td class="text-right" :colspan="search.type === 0 || search.type === 2 ? 1 : 2">
            總計
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_account') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_0') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_1') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_2') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_3') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_4') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_5') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_6') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_7') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_8') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_9') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_Y') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_F') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_S') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_B') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'total_sum') }}
          </td>
        </tr>
      </template>
    </tables-page>

    <!-- 詳細報表 modal -->
    <detailed-report-modal
      v-model="status.detailedReportModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate, getTodayDate, getFirstAndLastDayOfMonth, convertDateFormat, calculateRowsSum } from "@/models/HELPERS/common.js";
import DetailedReportModal from './components/modal/DetailedReportModal.vue';

export default {
  name: 'paidReport',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker,
    DetailedReportModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '查詢已繳費', url: '', isActive: false }
        ]
      },
      search: {
        type: 0,
        pay_date_S: '',
        pay_date_E: '',
        updated_date_S: '',
        updated_date_E: ''
      },
      status: {
        isNew: false,
        detailedReportModal: false
      },
      options: {
        type: [
          {
            value: 0,
            text: '日期'
          },
          {
            value: 1,
            text: '業務'
          },
          {
            value: 2,
            text: '編輯人'
          },
        ],
        payment: [
          {
            value: {
              type: 1,
              dateType: 'd'
            },
            text: '每[日]繳款(業務)'
          },
          // {
          //   value: {
          //     type: 1,
          //     dateType: 'd'
          //   },
          //   text: '每[日]繳款(行政)'
          // },
          {
            value: {
              type: 1,
              dateType: 'm'
            },
            text: '每[月]繳款(業務)'
          },
          {
            value: {
              type: 0,
              dateType: 'm'
            },
            text: '每[月]繳款(日期)'
          },
        ]
      },
      data: {
        table_data: [],
        table_base_fields: [
          {
            key: "total_account",
            label: "應收金額",
          },
          {
            key: "total_0",
            label: "現金"
          },
           {
            key: "total_1",
            label: "全家"
          },
          {
            key: "total_2",
            label: "新光"
          },
          {
            key: "total_3",
            label: "萬事達"
          },
          {
            key: "total_4",
            label: "郵局臨櫃"
          },
          {
            key: "total_5",
            label: "郵局劃撥"
          },
          {
            key: "total_6",
            label: "網路ATM"
          },
          {
            key: "total_7",
            label: "台中商銀"
          },
          {
            key: "total_8",
            label: "支票"
          },
          {
            key: "total_9",
            label: "自動"
          },
          // {
          //   key: "total_10",
          //   label: "年費抵用券"
          // },
          {
            key: "total_Y",
            label: "平台年費"
          },
          {
            key: "total_F",
            label: "上期手續費"
          },
          {
            key: "total_S",
            label: "回饋金"
          },
          {
            key: "total_B",
            label: "墊繳手續費"
          },
          {
            key: "total_sum",
            label: "合計"
          },
          {
            key: "",
            label: "備註"
          }
        ],
        // table_fields: [
        //   {
        //     key: "",
        //     label: "單號",
        //   },
        //   {
        //     key: "",
        //     label: "契約編號",
        //   },
        //   {
        //     key: "",
        //     label: "姓名",
        //   },
        //   {
        //     key: "",
        //     label: "期別"
        //   },
        //    {
        //     key: "",
        //     label: "類別"
        //   },
        //   {
        //     key: "",
        //     label: "繳費期限"
        //   },
        //   {
        //     key: "",
        //     label: "互助金"
        //   },
        //   {
        //     key: "",
        //     label: "繳費日期"
        //   },
        //   {
        //     key: "",
        //     label: "繳費來源"
        //   },
        //   {
        //     key: "",
        //     label: "業務編號"
        //   },
        //   {
        //     key: "",
        //     label: "業務姓名"
        //   },
        //   {
        //     key: "",
        //     label: "異動時間"
        //   },
        //   {
        //     key: "",
        //     label: "建檔帳號"
        //   }
        // ],
        temp_table_data: {},
        total: 0
      }
    }
  },
  // 在路由離開前觸發邏輯
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("paidReport");

    next();
  },
  computed: {
    tableFields() {
      let fields = JSON.parse(JSON.stringify(this.data.table_base_fields));

      if (this.search.type === 0) {
        fields.unshift({
          key: "payment_at",
          label: "繳款日期",
        })
      } else if (this.search.type === 1) {
        fields.unshift({
          key: "sales_number",
          label: "業務編號",
        },
        {
          key: "sales_name",
          label: "業務姓名",
        })
      } else if (this.search.type === 2) {
        fields.unshift({
          key: "updated_name",
          label: "編輯人",
        })
      }

      return fields;
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      const paidReport = sessionStorage.getItem("paidReport") || null;

      if (paidReport) {
        this.search = JSON.parse(paidReport);

        this.getBillReport();
      }

      // if (Object.keys(this.$route.query).length > 0) {
      //   this.search.payment = this.$route.query;

      //   this.getBillReport();
      // }
    },
    convertRocDate,
    calculateRowsSum,
    // 開啟編輯modal
    openModal(item = null) {
      this.status.isNew = item ? false : true;

      this.$root.$emit('bv::show::modal', 'contractPromotionSetting-modal');
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 查詢帳單報表
    getBillReport() {
      const params = {
        // 'type': this.search.payment.type,
        // ...this.dateParamsHandler(),
        ...this.search
      };
      this.billApi.getBillReport((response) => {
        const res = response.data;

        this.data.table_data = res.data;
        this.data.total = res.total;
      }, params)
    },
    // 日期參數處理
    dateParamsHandler() {
      const { dateType } = this.search.payment;
      const params = {
        pay_date_S: '',
        pay_date_E: ''
      }

      if (dateType === 'd') {
        // params.pay_date_S = getTodayDate();
        // params.pay_date_E = getTodayDate();
        params.pay_date_S = '2023-06-02';
        params.pay_date_E = '2023-06-02';
      } else if (dateType === 'm') {
        params.pay_date_S = getFirstAndLastDayOfMonth().first_day;
        params.pay_date_E = getFirstAndLastDayOfMonth().last_day;
      }

      return params;
    },
    // 改變顯示方式
    changeType() {
      const { pay_date_S, pay_date_E } = this.search;

      if (pay_date_S && pay_date_E) this.searchBillReport();
    },
    // 查詢帳單報表
    searchBillReport() {
      // this.$router.push({
      //   path: '/backstage/yf/paidReport',
      //   query: {
      //     ...this.search.payment
      //   }
      // }).then(() => {
      //   this.getBillReport();
      // })
      const required =
        ['type',
        'pay_date_S',
        'pay_date_E'];
      const data = this.search;
      const status = required.every(item => data[item] != null && data[item] !== '');

      if (!status) {
        const result = { message: '條件請選擇完整', title: '查詢已繳費' };
        this.billApi.toast(() => {}, result, false);

        return;
      }

      sessionStorage.setItem("paidReport", JSON.stringify(this.search));
      this.getBillReport();
    },
    // 詳細報表
    detailedReport(item = null, status = '') {
      let sales_number = '', updated_id = '', pay_date_S = '', pay_date_E = '';

      if (status === 'all_total_sum') {
        sales_number = '';
        updated_id = '';
        pay_date_S = this.search.pay_date_S;
        pay_date_E = this.search.pay_date_E;
      } else {
        if (this.search.type === 0) {
          sales_number = '';
          updated_id = '';
          pay_date_S = convertDateFormat(item.payment_at, false);
          pay_date_E = convertDateFormat(item.payment_at, false);
        } else if (this.search.type === 1) {
          sales_number = item.sales_number;
          updated_id = '';
          pay_date_S = this.search.pay_date_S;
          pay_date_E = this.search.pay_date_E;
        } else if (this.search.type === 2) {
          sales_number = '';
          updated_id = item.updated_id;
          pay_date_S = this.search.pay_date_S;
          pay_date_E = this.search.pay_date_E;
        }
      }

      const data = {
        class: 0,
        sales_number: sales_number,
        updated_id: updated_id,
        payment_source: this.filterClickData(item, status).payment,
        total: this.filterClickData(item, status).total,
        bill_type: this.filterClickData(item, status).type,
        pay_date_S: pay_date_S,
        pay_date_E: pay_date_E
      }

      this.data.temp_table_data = Object.assign({}, data);

      this.status.detailedReportModal = true;
    },
    // 篩選點擊資料
    filterClickData(item, status) {
      let payment = '', total = 0, type = 'M';

      switch (status) {
        case 'account':
          total = item.total_account;
          break;
        case 0:
          payment = '現金';
          total = item.total_0;
          break;
        case 1:
          payment = '全家';
          total = item.total_1;
          break;
        case 2:
          payment = '新光';
          total = item.total_2;
          break;
        case 3:
          payment = '萬事達';
          total = item.total_3;
          break;
        case 4:
          payment = '郵局臨櫃';
          total = item.total_4;
          break;
        case 5:
          payment = '郵局劃撥';
          total = item.total_5;
          break;
        case 6:
          payment = '網路ATM';
          total = item.total_6;
          break;
        case 7:
          payment = '台中商銀';
          total = item.total_7;
          break;
        case 8:
          payment = '支票';
          total = item.total_8;
          break;
        case 9:
          payment = '自動';
          total = item.total_9;
          break;
        // case 10:
        //   payment = '年費抵用券';
        //   total = item.total_10;
        //   type = '';
        //   break;
        case 'Y':
          total = item.total_Y;
          type = status;
          break;
        case 'F':
          total = item.total_F;
          type = status;
          break;
        case 'S':
          total = item.total_S;
          type = status;
          break;
        case 'B':
          total = item.total_B;
          type = status;
          break;
        case 'sum':
          total = item.total_sum;
          type = '';
          break;
        case 'all_total_sum':
          total = this.data.total;
          type = '';
          break;
      }

      return {
        payment: payment,
        total: total,
        type: type
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  align-items: left;
  flex-direction: column;
  white-space: nowrap;
  .badge {
    background: #ddb0b0;
    color: #FFFFFF;
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/paidReport.vue